export default class CountrySettingsClient {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.getCountrySettings = this.getCountrySettings.bind(this);
        this.getCountrySetting = this.getCountrySetting.bind(this);
        this.postCountrySetting = this.postCountrySetting.bind(this);
        this.putCountrySetting = this.putCountrySetting.bind(this);
        this.deleteCountrySetting = this.deleteCountrySetting.bind(this);
    }
    getCountrySettings(config) {
        return this.apiClient.get('/v3/country_settings', config);
    }
    getCountrySetting(id, config) {
        return this.apiClient.get(`/v3/country_settings/${id}`, config);
    }
    postCountrySetting(data, config) {
        return this.apiClient.post('/v3/country_settings', data, config);
    }
    putCountrySetting(id, data, config) {
        return this.apiClient.put(`/v3/country_settings/${id}`, data, config);
    }
    deleteCountrySetting(id, config) {
        return this.apiClient.delete(`/v3/country_settings/${id}`, config);
    }
}
